export default __webpack_public_path__ + "static/media/FE_ticket_event.c80cdc98.svg";